'use client';

import { __rest, __assign } from '../_virtual/_tslib.js';
import React__default from 'react';
import Col from '../LayoutSystem/Col.js';
import Row from '../LayoutSystem/Row.js';

var Container = React__default.forwardRef(function (_a, ref) {
    var children = _a.children, _b = _a.full, full = _b === void 0 ? false : _b, _c = _a.noOffset, noOffset = _c === void 0 ? false : _c; _a.container; var props = __rest(_a, ["children", "full", "noOffset", "container"]);
    var size = full ? 'full' : 'vnw';
    var xsOffset = noOffset ? 0 : 8;
    var smOffset = noOffset ? 0 : 16;
    return (React__default.createElement(Row, __assign({ ref: ref, container: {
            responsive: {
                xs: {
                    size: size,
                    offset: xsOffset
                },
                sm: {
                    size: size,
                    offset: smOffset
                }
            }
        } }, props),
        React__default.createElement(Col, null, children)));
});

export { Container as default };
//# sourceMappingURL=index.js.map
